import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { apiStore } from "../../api/ApiFactory";
import { useSelector } from "react-redux";
import { getClaimLookupsLoaded } from "../../store/slices/WarrantyClaim/WarrantyClaimSelector";

const WarrantyClaimIndex = () => {

    const dataloaded = useSelector(getClaimLookupsLoaded);

    //Used by Warranty Claim and Warranty Pre-Auths. Loads lookups to state before rendering pages.
    useEffect(() => {
        apiStore.lookupApi.loadClaimLookupsToStore();
    }, []);

    if(!dataloaded) {
        return <></>
    }

    return (
        <>
        <Outlet />
        </>
    );
};

export default WarrantyClaimIndex;
